import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { INFO_ROUTES } from '@features/info/info.routes';
import { QUESTIONNAIRE_ROUTES } from '@features/questionnaire/questionnaire.routes';
import { SentryExample } from './sentry-example.component';

const routes: Routes = [
  ...QUESTIONNAIRE_ROUTES,
  {
    path: 'testSentry',
    component: SentryExample,
  },
  ...INFO_ROUTES,
  {
    path: 'admin',
    loadChildren: () => import('@features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
